<!--
  ~ Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
  ~ Spin in het Web B.V. Apeldoorn.
  ~ Deze software mag alleen gebruikt / bekeken / gewijzigd worden
  ~ volgens de voorwaarden die zijn vastgelegd in de overeenkomst
  ~ tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
  ~ overeenkomsten tussen Slimme Infrasoftware B.V en
  ~ Spin in het Web B.V.
  -->

<div class="totaalexport">
    <div class="uitleg">Hiermee maak je een Excel-bestand met alle planitems en werkbonnen in het systeem, voor zover je
        toegangsrechten dit toestaan.
    </div>
    <div class="container">
        <div class="row">
            <div class="col-8 w-col-xs-6 w-col-md-4 mb-2">
                <label class="d-block mb-1">Periode:</label>
                <input type="text"
                       class="form-control mr-2"
                       bsDaterangepicker
                       [bsConfig]="{ isAnimated: true, adaptivePosition: false }"
                       [(ngModel)]="ux.exportDaterange"
                       (ngModelChange)="exportDaterangeGewijzigd()"
                       placeholder="(alles)"/>
            </div>
            <div class="w-col-xs-6 w-col-md-8 mb-2">
                <div class="align-self-end mb-2">
                    <div class="btn-group btn-group-sm" role="group">
                        <button class="btn btn-primary" type="button" (click)="setAlles()">Alles</button>
                        <button class="btn btn-primary" type="button" (click)="setDezeMaand()">Deze maand</button>
                        <button class="btn btn-primary" type="button" (click)="setDitKwartaal()">Dit kwartaal</button>
                        <button class="btn btn-primary" type="button" (click)="setDitJaar()">Dit jaar</button>
                    </div>
                </div>
                <div class="mb-2">
                    <div class="btn-group btn-group-sm" role="group">
                        <button class="btn btn-primary" type="button" (click)="setVorigeMaand()">Vorige maand</button>
                        <button class="btn btn-primary" type="button" (click)="setVorigKwartaal()">Vorig kwartaal
                        </button>
                        <button class="btn btn-primary" type="button" (click)="setVorigJaar()">Vorig jaar</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            @if (magFilteren) {
                <div class="w-col-12 mb-2 d-flex align-items-start">
                    <button class="btn mr-2" [ngClass]="heeftActiefFilter ? 'btn-info' : 'btn-outline-secondary'"
                            title="Open Filtertool"
                            (click)="openFiltertool()">
                        <span class="fas fa-filter"></span>
                        <span class="visually-hidden">Filter</span>
                    </button>
                    <div class="align-self-end">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" [id]="id('filteractief')"
                                   [(ngModel)]="ux.filterActief"
                                   (ngModelChange)="filterActiefGewijzigd()">
                            <label class="custom-control-label" [for]="id('filteractief')"
                                   title="Schakel toepassen van filters aan of uit">Filter toepassen</label>
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>
    <div class="justify-content-center d-flex mb-2">
        <button class="btn btn-primary" (click)="exporteer()">Exporteer</button>
    </div>
    <div class="uitleg text-success">{{exportstatus}}</div>
</div>
